import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vt-not-found-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent {}
